<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path :fill="fill"
      d="M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z" />
  </svg>
</template>

<script setup lang="ts">
const { width = '16px', height = '16px', fill = '#A9A9A9' } = defineProps<{
  width: string,
  height: string,
  fill: string,
}>()
</script>
